import React from 'react';
import styled from 'styled-components';

const StyleArticleVideo = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.bodyShade};
`;

const EmbedContainer = styled.div`
  position: relative;
  padding: 56.07% 0 0 0;
  margin-top: 4em;
  .VimeoOuterContainer {
    position: absolute;
    top: 0;
    left: 0;
    background-color: black !important;
  }
  @media all and (min-width: 600px) {
    padding: 38.07% 0 0 0;
  }
`;

interface IArticlerVideo {
  video?: string | undefined;
}
export const ArticleVideo: React.FC<IArticlerVideo> = ({ video }) => {
  return (
    <StyleArticleVideo>
      <EmbedContainer>
        <iframe
          className="VimeoOuterContainer"
          src={video}
          frameBorder="0"
          width="100%"
          height="100%"
        ></iframe>
      </EmbedContainer>
    </StyleArticleVideo>
  );
};
